export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13221.eda46f39.jpg";